import request from '@/utils/request'

export function getCurrency(data)
{
    return request({
        url: 'web/getCurrency',
        method: 'get',
        params: data
    })
}

export function getCurrencyType()
{
    return request({
        url: 'web/getCurrencyType',
        method: 'get'
    })
}
export function getAsset(data)
{
    return request({
        url: 'web/getAsset',
        method: 'get',
        params: data
    })
}
export function getAsset2(data)
{
    return request({
        url: 'web/getAsset2',
        method: 'get',
        params: data
    })
}
export function getAddressList(data)
{
    return request({
        url: 'web/getAddressList',
        method: 'get',
        params: data
    })
}

// 编辑地址
export function editAddress(data) {
    return request({
        url: 'web/editAddress',
        method: 'post',
        data
    })
}

// 删除地址
export function delAddress(data) {
    return request({
        url: 'web/delAddress',
        method: 'post',
        data
    })
}

// 添加地址
export function addAddress(data) {
    return request({
        url: 'web/addAddress',
        method: 'post',
        data
    })
}

export function getWalletLine(data) {
    return request({
        url: 'web/getWalletLine',
        method: 'get',
        params: data
    })
}

// 提币
export function tokeMoney(data) {
    return request({
        url: 'web/tokeMoney',
        method: 'post',
        data
    })
}

export function getWalletLog(data) {
    return request({
        url: 'web/getWalletLog',
        method: 'get',
        params: data
    })
}

export function geTransfer(data) {
    return request({
        url: 'web/geTransfer',
        method: 'get',
        params: data
    })
}

export function assetTransfer(data) {
    return request({
        url: 'web/assetTransfer',
        method: 'post',
        data
    })
}

export function assetRecharge(data) {
    return request({
        url: 'web/assetRecharge',
        method: 'post',
        data
    })
}

// 创建订单
export function createOrder(data)
{
    return request({
        url: 'web/createOrder',
        method: 'post',
        data
    })
}
// 获取委托
export function getWeiTuo(data){
    return request({
        url: 'web/getWeiTuo',
        method: 'get',
        params: data
    })
}

// 撤单
export function orderCancel(data) {
    return request({
        url: 'web/orderCancel',
        method: 'post',
        data
    })
}

// 交易日志
export function getDealLog(data) {
    return request({
        url: 'web/myLog',
        method: 'get',
        params: data
    })
}

// 充币记录
export function rechargeLog(data) {
    return request({
        url: 'web/rechargeLog',
        method: 'get',
        params: data
    })
}
// 提币记录
export function takeLog(data) {
    return request({
        url: 'web/takeLog',
        method: 'get',
        params: data
    })
}
export function getPositionList(data){
    return request({
        url: 'web/getPositionList',
        method: 'get',
        params: data
    })
}

export function cancalPosition(data) {
    return request({
        url: 'web/cancalPosition',
        method: 'post',
        data
    })
}

export function closePosition(data) {
    return request({
        url: 'web/closePosition',
        method: 'post',
        data
    })
}

export function getClosePositionList(data){
    return request({
        url: 'web/getClosePositionList',
        method: 'get',
        params: data
    })
}

export function editPosition(data) {
    return request({
        url: 'web/editPosition',
        method: 'post',
        data
    })
}
//获取币种列表
export function getChainList(data) {
    return request({
        url: 'web/getChainList',
        method: 'get',
        params: data
    })
}

//
export function getCenterLevel(data) {
    return request({
        url: 'web/getCenterLevel',
        method: 'get',
        params: data
    })
}
//地址认证
export function setAddressAuth(data) {
    return request({
        url: 'web/setAddressAuth',
        method: 'post',
        data: data
    })
}
// 获取币种
export function getmarketList(data) {
    return request({
        url: 'web/getmarketList',
        method: 'get',
        params: data
    })
}
// 上传图片
export function upload(data) {
    return request({
        url: '/web/uploadImg',
        method: 'post',
        data
    })
}
// 获取持仓列表
export function cutOrderList(data) {
    return request({
        url: 'web/cutOrderList',
        method: 'get',
        params: data
    })
}
// 快捷买币列表
export function getQuick(data) {
    return request({
        url: 'web/getQuick',
        method: 'get',
        params: data
    })
}
// 快捷买币列表
export function getParam() {
    return request({
        url: 'web/getParam',
        method: 'get',
    })
}
// 消息列表
export function getMessageList(data) {
    return request({
        url: 'web/getMessageList',
        method: 'get',
        params: data
    })
}
// 消息详情
export function getMessage(data) {
    return request({
        url: 'web/getMessage',
        method: 'get',
        params: data
    })
}
// 到期时间
export function cutTimeList(data) {
    return request({
        url: 'web/cutTimeList',
        method: 'get',
        params: data
    })
}
// 下单
export function cutBuy(data) {
    return request({
        url: 'web/cutBuy',
        method: 'post',
        data: data
    })
}
//
export function cutOrder(data) {
    return request({
        url: 'web/cutOrder',
        method: 'get',
        params: data
    })
}
//
export function newData(data) {
    return request({
        url: 'web/new_data',
        method: 'get',
        params: data
    })
}
// 帮助中心
export function getTextsList(data) {
    return request({
        url: 'web/getTextsList',
        method: 'get',
        params: data
    })
}
// 银行信息
export function hasBankinfo(data) {
  return request({
      url: 'web/hasBankinfo',
      method: 'get',
      params: data
  })
}
export function cutBuyadd(data) {
  return request({
      url: 'web/cutBuyadd',
      method: 'post',
      data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/asset.js